import { useCallback } from "react";
import { useLocation } from "react-router-dom-v5-compat";
import {
  SelfServeRawEventName,
  useEmitCoreSelfServeRawEvent,
} from "@b2bportal/core-self-serve";

import { getSupportHubProperties } from "../shared/ContactSupportModal/supportHubTracking";

export const useTrackTappedSuggestionChip = () => {
  const { pathname } = useLocation();
  const emitTappedSuggestionChip = useEmitCoreSelfServeRawEvent(
    SelfServeRawEventName.TappedSuggestionChip
  );

  return useCallback(
    (chipName: string) =>
      emitTappedSuggestionChip({
        properties: { ...getSupportHubProperties(pathname), chipName },
      }),
    [emitTappedSuggestionChip, pathname]
  );
};

export const useTrackSubmittedQuery = () => {
  const { pathname } = useLocation();
  const emitSubmittedQuery = useEmitCoreSelfServeRawEvent(
    SelfServeRawEventName.SubmittedQuery
  );

  return useCallback(
    (query: string) =>
      emitSubmittedQuery({
        properties: { ...getSupportHubProperties(pathname), query },
      }),
    [emitSubmittedQuery, pathname]
  );
};
